export const VERDICT_COLORS: Record<string, string> = {
  pass: '#4caf50',
  warning: '#ff9800',
  fail: '#f44336',
  na: '#9e9e9e',
};
